//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue'
export default {
  components: {
    'user-header': userHeader
  },
  props: {
    title: {
      type: String, default: '语音验证'
    },
    phone: {
      type: [Number, String], default: '未传入手机号'
    }
  },
  methods: {
    // 点击取消跳转
    voiceClose () {
      this.$emit('loginSwitch', 3)
    }
  }
}
